
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.917.406c.262-.25.618-.39.989-.39.37 0 .726.14.988.39L7.5 4.788 12.104.406c.129-.127.283-.228.454-.298a1.46 1.46 0 011.54.282c.131.125.235.273.306.437a1.275 1.275 0 01-.01 1.029 1.33 1.33 0 01-.313.432L8.488 7.61c-.263.25-.618.39-.989.39-.37 0-.726-.14-.989-.39L.917 2.288a1.299 1.299 0 01-.41-.941c0-.353.148-.691.41-.94z","fill":"#0D69D5"}})])
          )
        }
      }
    